module.exports = __webpack_public_path__ + "static/media/top-img_7.b54e8090.png";